export default () => {
    return {
        diffInSec: 0,
        remaining: 0,
        init() {
            this.remaining = parseInt(this.diffInSec)

            if (this.remaining > 0) {
                setInterval(() => {
                    this.setRemaining();
                }, 1000);
            }
        },
        setRemaining() {
            this.remaining = this.remaining - 1
        },
        days() {
            return {
                value: this.remaining / 86400,
                remaining: this.remaining % 86400
            };
        },
        hours() {
            return {
                value: this.days().remaining / 3600,
                remaining: this.days().remaining % 3600
            };
        },
        minutes() {
            return {
                value: this.hours().remaining / 60,
                remaining: this.hours().remaining % 60
            };
        },
        seconds() {
            return {
                value: this.minutes().remaining,
            };
        },
        format(value) {
            value = parseInt(value) >= 0 ? value : 0;
            return ("0" + parseInt(value)).slice(-2)
        },
        formatDate(value) {
            value = parseInt(value) >= 0 ? value : 0;
            return parseInt(value);
        },
        time() {
            return {
                days: this.formatDate(this.days().value),
                hours: this.format(this.hours().value),
                minutes: this.format(this.minutes().value),
                seconds: this.format(this.seconds().value),
            }
        },
    }
}
